import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-widgets-empty',
  templateUrl: './widgets-empty.component.html',
  styleUrls: ['./widgets-empty.component.scss'],
  standalone: false
})
export class WidgetsEmptyComponent {
  @Input() isStoreView: boolean = false;
  @Output() setFavoritesWidgets: EventEmitter<void> = new EventEmitter<void>();
}
